(function (root) {
  'use strict';

  function prefillAccountEmail(embed, email) {
    var field = embed && embed.shadowRoot && embed.shadowRoot.querySelector('input[data-testid="field-email"]');
    if (!field) return false;
    // Keep anything the customer or Shop has already supplied. Do not submit or opt in.
    if (field.value) return true;
    var setter = Object.getOwnPropertyDescriptor(root.HTMLInputElement.prototype, 'value').set;
    setter.call(field, email);
    field.dispatchEvent(new root.Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new root.Event('change', { bubbles: true, composed: true }));
    return true;
  }

  function prepareReservationFields(embed) {
    var shadow = embed && embed.shadowRoot;
    var email = shadow && shadow.querySelector('input[data-testid="field-email"]');
    if (!email) return null;
    email.autocomplete = 'email';
    email.inputMode = 'email';
    var quantity = shadow.querySelector('input[type="number"]');
    if (!quantity) return null;
    quantity.min = '1';
    quantity.max = '12';
    quantity.step = '1';
    var label = shadow.querySelector('label[for="' + quantity.id + '"]');
    var document = shadow.ownerDocument;
    var control = document.createElement('div');
    control.dataset.mintQuantityControl = 'true';
    var stepper = document.createElement('div');
    stepper.dataset.mintQuantityStepper = 'true';
    var decrease = document.createElement('button');
    decrease.type = 'button';
    decrease.dataset.mintQuantityStep = '-1';
    decrease.setAttribute('aria-label', 'Remove one paddle');
    decrease.textContent = '−';
    var center = document.createElement('div');
    center.dataset.mintQuantityCenter = 'true';
    var counter = document.createElement('input');
    counter.type = 'text';
    counter.id = quantity.id + '-counter';
    counter.dataset.mintQuantityValue = 'true';
    counter.readOnly = true;
    counter.inputMode = 'none';
    counter.autocomplete = 'off';
    counter.setAttribute('role', 'spinbutton');
    counter.setAttribute('aria-valuemin', '1');
    counter.setAttribute('aria-valuemax', '12');
    counter.setAttribute('aria-label', quantity.id.includes('additional') ? 'Additional paddles (1–12)' : 'Paddles to reserve (1–12)');
    var unit = document.createElement('span');
    unit.dataset.mintQuantityUnit = 'true';
    unit.setAttribute('aria-hidden', 'true');
    center.append(counter);
    center.append(unit);
    var increase = document.createElement('button');
    increase.type = 'button';
    increase.dataset.mintQuantityStep = '1';
    increase.setAttribute('aria-label', 'Add one paddle');
    increase.textContent = '+';
    stepper.append(decrease);
    stepper.append(center);
    stepper.append(increase);
    var error = document.createElement('p');
    error.id = counter.id + '-error';
    error.dataset.mintQuantityError = 'true';
    error.hidden = true;
    error.setAttribute('role', 'alert');
    var announcement = document.createElement('span');
    announcement.dataset.mintQuantityAnnouncement = 'true';
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    control.append(stepper);
    control.append(error);
    control.append(announcement);
    quantity.after(control);
    quantity.dataset.mintQuantitySource = 'true';
    var field = quantity.parentElement;
    field.dataset.mintQuantityField = 'true';
    var previousTabIndex = quantity.getAttribute('tabindex');
    var previousAriaHidden = quantity.getAttribute('aria-hidden');
    quantity.setAttribute('tabindex', '-1');
    quantity.setAttribute('aria-hidden', 'true');
    if (label) {
      label.htmlFor = counter.id;
      label.textContent = counter.getAttribute('aria-label');
      counter.setAttribute('aria-labelledby', label.id);
    }
    function mirrorQuantityState() {
      counter.disabled = quantity.disabled;
      decrease.disabled = quantity.disabled || Number(counter.value) <= 1;
      increase.disabled = quantity.disabled || Number(counter.value) >= 12;
      ['aria-invalid', 'aria-describedby'].forEach(function (name) {
        var value = quantity.getAttribute(name);
        if (value === null) counter.removeAttribute(name);
        else counter.setAttribute(name, value);
      });
      if (!error.hidden) counter.setAttribute('aria-describedby', error.id);
      stepper.setAttribute('aria-invalid', counter.getAttribute('aria-invalid') === 'true' ? 'true' : 'false');
    }
    function setQuantity(value) {
      var number = Math.max(1, Math.min(12, Math.round(Number(value) || 1)));
      counter.value = String(number);
      counter.setAttribute('aria-valuenow', String(number));
      counter.setAttribute('aria-valuetext', number + (number === 1 ? ' paddle' : ' paddles'));
      unit.textContent = number === 1 ? 'paddle' : 'paddles';
      announcement.textContent = counter.getAttribute('aria-valuetext') + ' selected';
      error.hidden = true;
      quantity.setCustomValidity('');
      quantity.removeAttribute('aria-invalid');
      if (quantity.value !== counter.value) {
        var setter = Object.getOwnPropertyDescriptor(root.HTMLInputElement.prototype, 'value').set;
        setter.call(quantity, counter.value);
        quantity.dispatchEvent(new root.Event('input', { bubbles: true, composed: true }));
        quantity.dispatchEvent(new root.Event('change', { bubbles: true, composed: true }));
      }
      mirrorQuantityState();
    }
    function decrement() { if (!decrease.disabled) setQuantity(Number(counter.value) - 1); }
    function increment() { if (!increase.disabled) setQuantity(Number(counter.value) + 1); }
    function quantityKeys(event) {
      if (counter.disabled) return;
      var values = { ArrowUp: Number(counter.value) + 1, ArrowDown: Number(counter.value) - 1, Home: 1, End: 12 };
      if (!Object.prototype.hasOwnProperty.call(values, event.key)) return;
      event.preventDefault();
      setQuantity(values[event.key]);
    }
    decrease.addEventListener('click', decrement);
    increase.addEventListener('click', increment);
    counter.addEventListener('keydown', quantityKeys);
    var quantityObserver = new root.MutationObserver(mirrorQuantityState);
    quantityObserver.observe(quantity, { attributes: true, attributeFilter: ['aria-invalid', 'aria-describedby', 'disabled'] });
    setQuantity(quantity.value);
    // Styling is scoped to this hosted form; Shopify keeps its field handlers,
    // consent control and submission. Stable field selectors fail safely.
    if (shadow.ownerDocument && !shadow.querySelector('[data-mint-form-style]')) {
      var style = shadow.ownerDocument.createElement('style');
      style.dataset.mintFormStyle = 'true';
      style.textContent = `
        [data-testid="form"] { gap: 18px !important; }
        [data-testid="form"] > div:has(> input) { display: flex; flex-direction: column-reverse; gap: 8px; }
        [data-testid="form"] > div > label { position: static !important; transform: none !important; padding: 0 !important; font-size: 12px !important; line-height: 1.5 !important; color: var(--body-text-color) !important; }
        [data-testid="form"] input:not([type="checkbox"]) { box-sizing: border-box; width: 100%; min-height: 52px; padding: 13px 14px !important; font-size: 16px !important; }
        [data-testid="form"] [data-mint-quantity-source] { display: none !important; }
        [data-testid="form"] > [data-mint-quantity-field] { flex-direction: column !important; }
        [data-mint-quantity-field] > label { order: -1; }
        [data-mint-quantity-stepper] { display: grid; grid-template-columns: 60px minmax(0, 1fr) 60px; min-height: 78px; border: 1px solid var(--mm-rule); background: color-mix(in srgb, var(--forms-accent-color) 10%, var(--form-background-color)); color: var(--body-text-color); }
        [data-mint-quantity-stepper][aria-invalid="true"] { border-color: var(--form-error-color); }
        [data-mint-quantity-step] { display: grid; place-items: center; min-width: 0; min-height: 76px; padding: 0; border: 0; border-radius: 0; background: transparent; color: inherit; font: 300 26px/1 var(--font-body-family, sans-serif); cursor: pointer; }
        [data-mint-quantity-step="-1"] { border-right: 1px solid var(--mm-panel-rule); }
        [data-mint-quantity-step="1"] { border-left: 1px solid var(--mm-panel-rule); }
        [data-mint-quantity-step]:hover:not(:disabled) { background: color-mix(in srgb, var(--forms-accent-color) 26%, transparent); }
        [data-mint-quantity-step]:disabled { opacity: .35; cursor: default; }
        [data-mint-quantity-step]:focus-visible, [data-testid="form"] input[data-mint-quantity-value]:focus-visible { outline: 2px solid var(--body-text-color); outline-offset: -4px; }
        [data-mint-quantity-center] { display: grid; align-content: center; justify-items: center; gap: 3px; padding: 8px; }
        [data-testid="form"] input[data-mint-quantity-value] { width: 100%; height: 35px; min-height: 0; padding: 0 !important; border: 0; border-radius: 0; background: transparent; color: inherit; box-shadow: none; font: 400 34px/1 var(--mm-serif) !important; text-align: center; caret-color: transparent; cursor: default; }
        [data-mint-quantity-unit] { font-size: 9px; line-height: 1.2; letter-spacing: .16em; text-transform: uppercase; }
        [data-mint-quantity-error] { margin: 8px 0 0; color: var(--form-error-color); font-size: 12px; line-height: 1.5; }
        [data-mint-quantity-error][hidden] { display: none; }
        [data-mint-quantity-announcement] { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip-path: inset(50%); white-space: nowrap; border: 0; }
        [data-testid="form"] fieldset { border: 0; padding: 0; margin: 0; }
        [data-testid="form"] fieldset label { font-size: 12px; line-height: 1.5; }
        [data-testid="form"] fieldset label span { font-size: 12px !important; line-height: 1.5 !important; }
        [data-testid="btn-form-submit"] { min-height: 52px; font-size: 14px; letter-spacing: .02em; }
        [data-testid="btn-form-submit"]:hover { filter: brightness(.96); }
        [data-testid="btn-form-submit"]:focus-visible { outline: 2px solid var(--body-text-color); outline-offset: 3px; }
      `;
      shadow.append(style);
    }
    var capture = {capture: true};
    function clearQuantityError(event) {
      if (event.target === quantity && quantity.validationMessage) {
        quantity.setCustomValidity('');
        quantity.removeAttribute('aria-invalid');
      }
    }
    function validateQuantity(event) {
      var number = Number(counter.value);
      var invalid = !counter.value || !Number.isInteger(number) || number < 1 || number > 12 || quantity.value !== counter.value;
      if (!invalid) return;
      quantity.setAttribute('aria-invalid', 'true');
      counter.setAttribute('aria-invalid', 'true');
      stepper.setAttribute('aria-invalid', 'true');
      error.textContent = 'Choose a whole number of paddles from 1 to 12.';
      error.hidden = false;
      counter.setAttribute('aria-describedby', error.id);
      event.preventDefault();
      event.stopImmediatePropagation();
      counter.focus();
    }
    // The app disables native form validation; enforce whole paddles before its
    // submit handler runs without submitting, replacing, or opting in a customer.
    shadow.addEventListener('input', clearQuantityError, capture);
    shadow.addEventListener('submit', validateQuantity, capture);
    return function () {
      shadow.removeEventListener('input', clearQuantityError, capture);
      shadow.removeEventListener('submit', validateQuantity, capture);
      quantity.setCustomValidity('');
      quantityObserver.disconnect();
      decrease.removeEventListener('click', decrement);
      increase.removeEventListener('click', increment);
      counter.removeEventListener('keydown', quantityKeys);
      control.remove();
      delete quantity.dataset.mintQuantitySource;
      delete field.dataset.mintQuantityField;
      if (previousTabIndex === null) quantity.removeAttribute('tabindex');
      else quantity.setAttribute('tabindex', previousTabIndex);
      if (previousAriaHidden === null) quantity.removeAttribute('aria-hidden');
      else quantity.setAttribute('aria-hidden', previousAriaHidden);
      if (label) label.htmlFor = quantity.id;
    };
  }

  if (root.customElements && !root.customElements.get('mint-reservation')) {
    root.customElements.define('mint-reservation', class extends root.HTMLElement {
      connectedCallback() {
        this.cancelPrefill();
        this.releaseFields?.();
        this.releaseFields = null;
        var email = this.dataset.customerEmail || '';
        var accountEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
        var attempts = 0;
        var tryPrefill = () => {
          this.prefillTimer = null;
          if (!this.isConnected) return;
          var embed = this.querySelector('shopify-forms-embed');
          this.releaseFields ||= prepareReservationFields(embed);
          if (this.releaseFields && (!accountEmail || prefillAccountEmail(embed, accountEmail))) {
            this.dataset.formState = 'ready';
            var loading = this.querySelector('[data-mint-loading]');
            var recovery = this.querySelector('[data-mint-recovery]');
            if (loading) loading.hidden = true;
            if (recovery) recovery.hidden = true;
            return;
          }
          // The app and its open shadow root mount asynchronously. Bound the wait.
          if (++attempts < 120) this.prefillTimer = root.setTimeout(tryPrefill, 250);
          else {
            this.dataset.formState = 'unavailable';
            var loading = this.querySelector('[data-mint-loading]');
            var recovery = this.querySelector('[data-mint-recovery]');
            if (loading) loading.hidden = true;
            if (recovery) recovery.hidden = false;
          }
        };
        var retry = this.querySelector('[data-mint-retry]');
        if (retry?.addEventListener) retry.addEventListener('click', () => root.location.reload(), {once: true});
        tryPrefill();
      }
      cancelPrefill() {
        if (this.prefillTimer != null) root.clearTimeout(this.prefillTimer);
        this.prefillTimer = null;
      }
      disconnectedCallback() { this.cancelPrefill(); this.releaseFields?.(); this.releaseFields = null; }
    });
  }

  function subscriptionRequest(email, companyId, listId, consent) {
    if (consent !== true) throw new Error('Please agree to receive Manhattan Mint emails.');
    var address = typeof email === 'string' ? email.trim() : '';
    if (address.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) throw new Error('Enter a valid email address.');
    if (!/^[A-Za-z0-9]{6}$/.test(companyId) || !/^[A-Za-z0-9]{6}$/.test(listId)) {
      throw new Error('Signup is temporarily unavailable. Please try again later.');
    }
    return {
      url: 'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId),
      options: {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Dope Manhattan Mint waitlist — email consent v1',
            profile: { data: { type: 'profile', attributes: {
              email: address,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        } })
      }
    };
  }

  async function subscribe(email, companyId, listId, consent, fetcher) {
    var request = subscriptionRequest(email, companyId, listId, consent);
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetcher(request.url, Object.assign({}, request.options, { signal: controller.signal }));
      // A 202 accepts the request. Double opt-in confirmation still happens in email.
      if (response.status === 202) return 'Check your inbox to confirm your email. If you already subscribed, you do not need to confirm again. Signup does not reserve a paddle.';
      if (response.status === 429) throw new Error('Too many signup requests. Please wait a moment and try again.');
      throw new Error('We could not accept your signup. Please try again, or contact us for help.');
    } finally {
      clearTimeout(timeout);
    }
  }

  function bind(container) {
    var form = container.querySelector('[data-mint-email-updates]');
    if (!form || form.dataset.waitlistBound) return;
    form.dataset.waitlistBound = 'true';
    form.hidden = false;
    var button = form.querySelector('[type="submit"]');
    var status = container.querySelector('[data-waitlist-status]');
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Sending your signup…';
      try {
        status.textContent = await subscribe(form.elements.email.value, container.dataset.companyId,
          container.dataset.listId, form.elements.consent.checked, root.fetch.bind(root));
        form.reset();
      } catch (error) {
        status.textContent = error.name === 'AbortError' ? 'Signup timed out. Please try again.' :
          error instanceof TypeError ? 'Check your connection and try again.' : error.message;
      } finally {
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { subscriptionRequest: subscriptionRequest, subscribe: subscribe, prefillAccountEmail: prefillAccountEmail, prepareReservationFields: prepareReservationFields };
  if (root.document) {
    root.document.querySelectorAll('[data-manhattan-waitlist]').forEach(bind);
    root.document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-manhattan-waitlist]').forEach(bind);
    });
  }
})(typeof window === 'undefined' ? globalThis : window);
